import { postAction, getAction, putAction, deleteAction } from '@/api/manage'
import { axios } from '@/utils/request'

const BASE = '/api/plugin/fixed-asset'

// ==================== 资产卡片 ====================
export const assetList = (p) => getAction(`${BASE}/assets`, p)
export const assetGet = (id) => getAction(`${BASE}/assets/${id}`)
// 更新（PUT /assets/{id}）或登记（POST /assets），按是否携带 id 自动分流
export const assetSave = (p) => (p.id != null ? putAction(`${BASE}/assets/${p.id}`, p) : postAction(`${BASE}/assets`, p))
export const assetDelete = (id) => deleteAction(`${BASE}/assets/${id}`)
// 折旧明细 / 变动历史（卡片详情 Tab）
export const assetDepreciationList = (id, p) => getAction(`${BASE}/assets/${id}/depreciations`, p)
export const assetChangeLogList = (id, p) => getAction(`${BASE}/assets/${id}/change-logs`, p)
// 维修记录（复用维修单列表接口，assetId 过滤）
export const repairListByAsset = (p) => getAction(`${BASE}/repairs`, p)

// ==================== 资产附件 ====================
export const attachmentList = (assetId) => getAction(`${BASE}/assets/${assetId}/attachments`)
export const attachmentUpload = (assetId, formData) => axios({
  url: `${BASE}/assets/${assetId}/attachments`,
  method: 'post',
  data: formData,
  headers: { 'Content-Type': 'multipart/form-data' }
})
export const attachmentView = (id) => axios({
  url: `${BASE}/attachments/${id}/view`,
  method: 'get',
  responseType: 'blob'
})
export const attachmentDelete = (id) => deleteAction(`${BASE}/attachments/${id}`)

// ==================== 期初资产导入 ====================
export const importTemplate = () => axios({
  url: `${BASE}/assets/import-template`,
  method: 'get',
  responseType: 'blob'
})
export const importAsset = (formData) => axios({
  url: `${BASE}/assets/import`,
  method: 'post',
  data: formData,
  headers: { 'Content-Type': 'multipart/form-data' }
})

// ==================== 资产类别 ====================
export const categoryList = () => getAction(`${BASE}/categories`)
export const categorySave = (p) => (p.id != null ? putAction(`${BASE}/categories/${p.id}`, p) : postAction(`${BASE}/categories`, p))
export const categoryDelete = (id) => deleteAction(`${BASE}/categories/${id}`)

// ==================== 折旧政策 ====================
export const policyList = (p) => getAction(`${BASE}/policies`, p)
export const policySave = (p) => (p.id != null ? putAction(`${BASE}/policies/${p.id}`, p) : postAction(`${BASE}/policies`, p))
export const policyDelete = (id) => deleteAction(`${BASE}/policies/${id}`)
export const policySetEnabled = (p) => putAction(`${BASE}/policies/${p.id}/enabled?value=${p.value}`)

// ==================== 资产物资 ====================
export const materialList = (p) => getAction(`${BASE}/materials`, p)
export const materialSetEnableAsset = (p) => putAction(`${BASE}/materials/${p.id}/enable-asset?value=${p.value}`)

// ==================== 转固单（三通道） ====================
export const transferList = (p) => getAction(`${BASE}/transfers`, p)
export const transferGet = (id) => getAction(`${BASE}/transfers/${id}`)
export const transferSave = (p) => (p.id != null ? putAction(`${BASE}/transfers/${p.id}`, p) : postAction(`${BASE}/transfers`, p))
export const transferDelete = (id) => deleteAction(`${BASE}/transfers/${id}`)
export const transferAudit = (id) => postAction(`${BASE}/transfers/${id}/audit`)
export const transferUnaudit = (id) => postAction(`${BASE}/transfers/${id}/unaudit`)
export const transferPayment = (id, p) => postAction(`${BASE}/transfers/${id}/payment`, p)
// 来源查询（防重复转固：已生成卡片的明细自动排除）
export const transferPurchaseOrders = (p) => getAction(`${BASE}/transfer/purchase-orders`, p)
export const transferInnerOuts = (p) => getAction(`${BASE}/transfer/inner-outs`, p)
export const transferSourceItems = (headerId) => getAction(`${BASE}/transfer/source-items`, { headerId })
// 转固单关联凭证（gledger 按来源单据追踪：资产转固+资产核销）
export const transferVouchers = (p) => getAction('/api/plugin/gledger/vouchers/by-source', p)

// ==================== 变动单 ====================
export const changeList = (p) => getAction(`${BASE}/changes`, p)
export const changeGet = (id) => getAction(`${BASE}/changes/${id}`)
export const changeSave = (p) => (p.id != null ? putAction(`${BASE}/changes/${p.id}`, p) : postAction(`${BASE}/changes`, p))
export const changeDelete = (id) => deleteAction(`${BASE}/changes/${id}`)
export const changeAudit = (id) => postAction(`${BASE}/changes/${id}/audit`)
export const changeUnaudit = (id) => postAction(`${BASE}/changes/${id}/unaudit`)

// ==================== 维修单 ====================
export const repairList = (p) => getAction(`${BASE}/repairs`, p)
export const repairGet = (id) => getAction(`${BASE}/repairs/${id}`)
export const repairSave = (p) => (p.id != null ? putAction(`${BASE}/repairs/${p.id}`, p) : postAction(`${BASE}/repairs`, p))
export const repairDelete = (id) => deleteAction(`${BASE}/repairs/${id}`)
export const repairAudit = (id) => postAction(`${BASE}/repairs/${id}/audit`)
export const repairUnaudit = (id) => postAction(`${BASE}/repairs/${id}/unaudit`)

// ==================== 调拨单 ====================
export const allocateList = (p) => getAction(`${BASE}/allocates`, p)
export const allocateGet = (id) => getAction(`${BASE}/allocates/${id}`)
export const allocateSave = (p) => (p.id != null ? putAction(`${BASE}/allocates/${p.id}`, p) : postAction(`${BASE}/allocates`, p))
export const allocateDelete = (id) => deleteAction(`${BASE}/allocates/${id}`)
export const allocateAudit = (id) => postAction(`${BASE}/allocates/${id}/audit`)
export const allocateUnaudit = (id) => postAction(`${BASE}/allocates/${id}/unaudit`)

// ==================== 处置报废单 ====================
export const disposalList = (p) => getAction(`${BASE}/disposals`, p)
export const disposalGet = (id) => getAction(`${BASE}/disposals/${id}`)
export const disposalSave = (p) => (p.id != null ? putAction(`${BASE}/disposals/${p.id}`, p) : postAction(`${BASE}/disposals`, p))
export const disposalDelete = (id) => deleteAction(`${BASE}/disposals/${id}`)
export const disposalAudit = (id) => postAction(`${BASE}/disposals/${id}/audit`)
export const disposalUnaudit = (id) => postAction(`${BASE}/disposals/${id}/unaudit`)

// ==================== 折旧计提单 ====================
export const depBillList = (p) => getAction(`${BASE}/dep-bills`, p)
export const depBillGet = (id) => getAction(`${BASE}/dep-bills/${id}`)
export const depBillPreview = (p) => postAction(`${BASE}/dep-bills/preview`, p)
export const depBillGenerate = (p) => postAction(`${BASE}/dep-bills/generate`, p)
export const depBillAudit = (id) => postAction(`${BASE}/dep-bills/${id}/audit`)
export const depBillUnaudit = (id) => postAction(`${BASE}/dep-bills/${id}/unaudit`)
export const depBillDelete = (id) => deleteAction(`${BASE}/dep-bills/${id}`)

// ==================== 资产报表（七张） ====================
export const reportDepDetail = (p) => getAction(`${BASE}/reports/dep-detail`, p)
export const reportLedger = (p) => getAction(`${BASE}/reports/ledger`, p)
export const reportChangeSummary = (p) => getAction(`${BASE}/reports/change-summary`, p)
export const reportIdleList = (p) => getAction(`${BASE}/reports/idle-list`, p)
export const reportBizfinCheck = (p) => getAction(`${BASE}/reports/bizfin-check`, p)
export const reportTaxAdjust = (p) => getAction(`${BASE}/reports/tax-adjust`, p)
export const reportSupplierStatement = (p) => getAction(`${BASE}/reports/supplier-statement`, p)
